'use strict';

var keys = require('./keys.js');

function removeNullValues(x) {
    if (!x) return undefined;
    return keys(x).reduce((results, key)=>{
        const value = x[key];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (value !== null) results[key] = value;
        return results;
    }, {});
}

module.exports = removeNullValues;
